import { GenericSuccess, useTheme, Theme, Link } from '@yuno/design-system-web'
import { navigateToUrl } from 'single-spa';
import { LinkA } from '../styles';
import { useTranslation } from 'react-i18next'

type ConnectionDrawerSuccess = {
  status: string
  name: string
}

export const ConnectionDrawerSuccess = ({
  status,
  name,
}: ConnectionDrawerSuccess) => {
  const theme: Theme = useTheme()
  const asyncProvider = status === 'PENDING'
  const { t } = useTranslation()

  const navigate = () => navigateToUrl('/routing')

  if (asyncProvider) {
    return (
      <GenericSuccess
        transparent
        icon="WarningCircle"
        iconSize="75"
        width={'351px'}
        iconColor={theme.palette.vivid.orange}
        title={t('connectionRequestIssued')}
        description={t('connectionRequestSended')}
      />
    )
  }

  return (
    <GenericSuccess
      transparent
      title={t('connectionAdded')}
      description={`${t('connectCompleteOne')}${name}${t('connectCompleteTwo')}`}
      link={'Routing'}
    >
      <LinkA href="#" onClick={navigate.bind(null)}>{t('connectCompleteFinal')}</LinkA>
    </GenericSuccess>
  )
}
